import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries, maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
import { slideInRule } from './slideIn';
export var ErrorBox = styled.div.withConfig({
  displayName: "ErrorBox",
  componentId: "sc-1fcoa06-0"
})(["position:fixed;z-index:300;top:0;left:0;right:0;padding:18px 84px 18px 30px;background:", ";", ";color:", ";backface-visibility:hidden;animation:", ";", ";", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.errorColor;
}, getFont(0, 'compact'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.errorFontColor;
}, slideInRule, minMediaQueries.miniDesktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    text-align: center;\n  "]))), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: 18px 72px 18px 24px;\n  "]))), maxMediaQueries.phone(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 18px 54px 18px 15px;\n  "]))));
export var Inner = styled.div.withConfig({
  displayName: "ErrorBox__Inner",
  componentId: "sc-1fcoa06-1"
})(["width:100%;", ";"], minMediaQueries.miniDesktop(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    max-width: ", ";\n    margin: 0 auto;\n  "])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.maxWidth;
}));